import styles from '@/styles/About.module.css'
import Head from 'next/head'
import dynamic from 'next/dynamic'

const Mexikanska = dynamic(() => import('@/components/Mexikanska'))

const Page = () => {
  return (
    <main className={styles.main}>
      <Head>
        <title>La Bambi Restaurang - Mexikanska Pizzor Meny</title>
        <meta
          name='description'
          content='Utmana din hettakärlek med vår sensationellt heta jalapeño mexikanska pizza! Gör dig redo för en smakexplosion av hetta och smaker med vår nya jalapeño mexikanska pizza. Denna pizza är fylld med riklig tomatsås, smakrik ost, marinerad oxfilé, tacokryddmix och tacosås, allt toppat med en hel jalapeño för den där extra kicken.'
        />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
      </Head>
      <Mexikanska title='Alla pizzor innehåller tomatsås och ost' />
    </main>
  )
}

export default Page
